import React from 'react';
import { CreditCardIcon, DumbbellIcon, FileTextIcon, LayersIcon, LockIcon, ShieldCheckIcon, UsersIcon, ZapIcon } from 'lucide-react';
import { heroStats, mockupUrl } from '../data/content';
import { Button } from './ui/Button';
const badges = [[FileTextIcon, '100% PDF + Videos'], [ZapIcon, 'Acceso en 5 min'], [DumbbellIcon, 'Principiante → Avanzado'], [LayersIcon, 'Todos los niveles'], [UsersIcon, 'Alumnos de todas las edades']] as const;
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-14" data-id="element-170" data-mp="xa4hxe516dg4">
      <div className="pointer-events-none absolute left-1/2 top-[22%] h-[560px] w-[560px] -translate-x-1/2 rounded-full bg-primary/10 blur-[120px]" data-id="element-171" data-mp="saruar6c52ch" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-172" data-mp="nbyhz22sbhdw">
        <div className="mb-5 inline-flex rounded-full border border-primary/20 bg-primary/10 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-primary md:mb-6" data-id="element-173" data-mp="3d2lb3gldnd2t">
          CompraDigitalYa™
        </div>
        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-black uppercase leading-[1.05] tracking-tight text-ink md:text-[3.6rem]" data-id="element-174" data-mp="3j925rpk1dsw2">
          🏃‍♀️ Combo Completo Jumping 2026
          <span className="mt-3 block text-xl normal-case text-primary md:text-4xl" data-id="element-175" data-mp="399bahlnnj9ux">
            Todo tu año de clases de Jumping. Listo. Desde hoy.
          </span>
        </h1>

        <a href="#pricing" className="group my-6 flex justify-center rounded-3xl focus:outline-none md:my-8" aria-label="Ver el precio del Combo Completo Jumping 2026" data-id="element-176" data-mp="30hhqfp8wzh0l">
          <img className="w-full max-w-[680px] object-contain drop-shadow-[0_26px_44px_rgba(219,39,119,.28)] transition-transform duration-300 ease-out group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Jumping 2026 con sus 5 módulos, 3 bonos y upsells" data-id="element-177" data-mp="2qkmsb7gjzimu" />
        </a>

        <p className="mx-auto max-w-3xl text-base font-semibold leading-relaxed text-slate-600 md:text-xl" data-id="element-178" data-mp="2ljz38rbvxbv9">
          <strong className="text-ink" data-id="element-179" data-mp="s44h9lcvphgu">
            El sistema N°1 para instructores de Jumping en Argentina.
          </strong>{' '}
          Principiante → Avanzado, todos los niveles. Clases + combinaciones + adaptaciones listos
          para usar. Sin buscar. Sin armar. Sin perder domingos.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold text-slate-600 md:text-sm" data-id="element-180" data-mp="dbaowzcid6ur">
          {badges.map(([BadgeIcon, label]) => <span key={label} className="flex items-center gap-1.5" data-id="element-181" data-mp="162cd1py6icqf">
              <BadgeIcon className="h-4 w-4 text-primary" data-id="element-182" data-mp="111okgzuaxnu3" />
              {label}
            </span>)}
        </div>

        <div className="mt-7" data-id="element-183" data-mp="x0l328wlvjqr">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-184" data-mp="3lsyt309hwojl">
            🏃‍♀️ QUIERO MI COMBO JUMPING AHORA →
          </Button>
        </div>

        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-slate-500 md:text-sm" data-id="element-185" data-mp="3htga4a18inje">
          <span className="flex items-center gap-1" data-id="element-186" data-mp="21amvn8ncdqlt">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-187" data-mp="21b63fwja2ym4" />
            Garantía 7 días
          </span>
          <span className="text-pink-300" data-id="element-188" data-mp="267whyfffpm5f">·</span>
          <span className="flex items-center gap-1" data-id="element-189" data-mp="2b0zd2rzv13nq">
            <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-190" data-mp="2b2sjq7ah3nvq" />
            Pago seguro
          </span>
          <span className="text-pink-300" data-id="element-191" data-mp="2g258ixkwn50y">·</span>
          <span className="flex items-center gap-1" data-id="element-192" data-mp="2kxucre7vda3l">
            <CreditCardIcon className="h-3.5 w-3.5 text-primary" data-id="element-193" data-mp="2l0qbh4rjk2t3" />
            Mercado Pago
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-194" data-mp="2u03lpznhovev">
          {heroStats.map(([value, label]) => <div key={label} className="rounded-2xl border border-pink-100 bg-white p-4 text-center shadow-sm" data-id="element-195" data-mp="unre77dds3y5">
              <p className="text-2xl font-black text-primary md:text-3xl" data-id="element-196" data-mp="4bdw1dmdg5nk">{value}</p>
              <p className="mt-1 text-[11px] font-bold leading-tight text-slate-500 md:text-sm" data-id="element-197" data-mp="4d76z540pc1d">
                {label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}